import { Image } from 'expo-image';
import { Modal, StyleSheet } from 'react-native';

import { checkIcon, warningIcon } from '@/assets/images/icons';
import Text from '@/components/Text';
import { useEndFlowModal } from '@/contexts/endFlowModalContext';
import { useColor } from '@/hooks/useColor';
import { i18n } from '@/utils/i18n';

import BrandedButton from '../buttons/BrandedButton';
import ModalCard from './ModalCard';

const EndFlowModal = () => {
  const colors = useColor();
  const {
    state: { message, title, type, visible, closeOnTapOutside, showCloseButton, buttonLabel, onButtonPress },
    dispatch
  } = useEndFlowModal();

  const buttonText = buttonLabel ?? i18n.t('mix.close');
  const source = type === 'success' ? checkIcon : warningIcon;

  const closeModal = () => {
    dispatch({ type: 'SET_VISIBLE', setVisible: false });
  };

  return (
    <Modal animationType="fade" transparent={true} visible={visible} statusBarTranslucent>
      <ModalCard closeModal={closeModal} closeOnTapOutside={closeOnTapOutside} showCloseButton={showCloseButton}>
        <Image source={source} contentFit={'contain'} style={styles.image} />
        <Text style={[styles.titleText, { color: colors.titleText }]}>{title}</Text>
        <Text style={styles.descriptionText}>{message}</Text>
        <BrandedButton
          style={styles.button}
          onPress={() => {
            if (onButtonPress) {
              onButtonPress();
            }
            closeModal();
          }}>
          {buttonText}
        </BrandedButton>
      </ModalCard>
    </Modal>
  );
};

const styles = StyleSheet.create({
  descriptionText: {
    fontSize: 14,
    textAlign: 'center',
    marginBottom: 34
  },

  titleText: {
    fontSize: 32,
    marginTop: 10,
    marginBottom: 12,
    textAlign: 'center'
  },

  button: {
    width: '100%',
    height: 37
  },

  image: {
    height: 70,
    width: 70
  }
});

export default EndFlowModal;
